module.exports = __webpack_public_path__ + "static/media/ranggi-2.a768d11b.jpg";